import { Suspense, useMemo } from "react";
import type { GridFilterModel } from "@mui/x-data-grid-premium";
import type {
  SupplierAgreementResource,
  SupplierResource,
} from "@exonn/js-sdk";
import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { useResourceFormData } from "src/components/Form/hooks/useResourceFormData.ts";
import { useGlobalModuleTabs } from "src/App/useGlobalModuleTabs.ts";
import { FormAction } from "src/components/Form/Form.types.ts";
import { useEditDeleteContextMenu } from "src/system/list/context-menu/useEditDeleteContextMenu.tsx";

// Соглашения (артикулы) поставщика; двойной клик или меню строки «Bearbeiten / Löschen».
// Новые соглашения создаются у товара (вкладка «Lieferanten»).
export const SupplierArticles = () => {
  const data = useResourceFormData<{ data: SupplierResource }>();
  const supplierId = data?.data?.id;
  const { api } = useGlobalModuleTabs();
  const openAgreement = (agreement: SupplierAgreementResource) =>
    api.openTab({
      resource: ResourceEnum.SupplierAgreement,
      type: "form",
      action: FormAction.Edit,
      id: agreement.id,
    });
  const contextMenu = useEditDeleteContextMenu<SupplierAgreementResource>({
    resource: ResourceEnum.SupplierAgreement,
    onEdit: openAgreement,
  });

  const filter = useMemo(
    (): GridFilterModel => ({
      items: [{ field: "supplier_id", operator: "is", value: supplierId }],
    }),
    [supplierId],
  );

  if (!supplierId) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ResourceList
        style={{ padding: 15 }}
        resource={ResourceEnum.SupplierAgreement}
        filter={filter}
        disableStatePersistenceToUrl
        hideToolbarCreateNewRecordButton
        onRowDoubleClick={({ row }: { row: SupplierAgreementResource }) =>
          openAgreement(row)
        }
        contextMenu={contextMenu}
      />
    </Suspense>
  );
};
